export type DebugStateProvider = () => unknown

const providers = new Map<string, DebugStateProvider>()

export const registerDebugStateProvider = (key: string, provider: DebugStateProvider): (() => void) => {
  providers.set(key, provider)
  return () => {
    if (providers.get(key) === provider) providers.delete(key)
  }
}

const safeInvoke = (provider: DebugStateProvider): unknown => {
  try {
    const value = provider()
    JSON.stringify(value)
    return value
  } catch (error) {
    return { __error: error instanceof Error ? error.message : String(error) }
  }
}

export const snapshotDebugAppState = (): Record<string, unknown> => {
  const snapshot: Record<string, unknown> = {}
  providers.forEach((provider, key) => {
    snapshot[key] = safeInvoke(provider)
  })
  if (typeof window !== 'undefined') {
    snapshot.window = {
      url: window.location.href,
      pathname: window.location.pathname,
      hash: window.location.hash,
      viewport: `${window.innerWidth}x${window.innerHeight}@${window.devicePixelRatio || 1}`,
      online: navigator.onLine,
    }
  }
  return snapshot
}
